import { httpPut } from "shared/api/apiHandler";
import urls from "shared/api/spaceStone/urls";

export const acceptPrivacyPolicy = async (): Promise<boolean> => {
    const result = await httpPut<boolean>(window.APP_SETTINGS.spaceStoneApiBaseUri, urls.POLICY.ACCEPT_POLICY, {});

    return result.data;
};
